import { Alert, Snackbar } from "@mui/material";
import { useState } from "react";
import { SnackbarContext } from "../contexts/SnackbarContext";

// updated
export default function SnackbarProvider(props: {
    children: JSX.Element | JSX.Element[];
}) {
    const [snackbars, setSnackbars] = useState<
        {
            content: string;
            severity: "success" | "error" | "warning" | "info";
        }[]
    >([]);
    let [timeoutHandler, setTimeoutHandler] = useState<any>(null);
    let [open, setOpen] = useState<boolean>(false);

    const showSnackbar = (content: string, severity: "success" | "error") => {
        setOpen(true);
        clearTimeout(timeoutHandler);
        setSnackbars([...snackbars, { content, severity }]);
        const handler = setTimeout(() => {
            setOpen(false);
        }, 5000);
        setTimeoutHandler(handler);
    };

    const snackbarContextValue = { snackbars, showSnackbar };

    const lastSnackbar = snackbars[snackbars.length - 1];

    return (
        <SnackbarContext.Provider value={snackbarContextValue}>
            {props.children}
            {lastSnackbar && (
                <Snackbar
                    open={open}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                    }}
                >
                    <Alert
                        elevation={6}
                        variant="filled"
                        severity={lastSnackbar.severity}
                        sx={{ width: "100%" }}
                    >
                        {lastSnackbar.content}
                    </Alert>
                </Snackbar>
            )}
        </SnackbarContext.Provider>
    );
}
